import React from 'react';
import { MODES } from 'utils/values';
import Field from './styled';

const MODE_LABELS = {
  honor: 'Honor',
  verified: 'Verified',
  audit: 'Audit',
};

const EnrollmentStatusSelect = ({
  value,
  availableModes = [],
  onChange,
  id,
  isPending = false,
}) => {
  const formatOptionLabel = (mode) => {
    const label = MODE_LABELS[mode] || mode;
    if (availableModes.includes(mode)) {
      return label;
    }
    return `${label} (unavailable)`;
  };

  return (
    <Field className={isPending ? 'is-pending' : ''}>
      <select
        id={id}
        className="form-control enrollment-status-select"
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        aria-label="Enrollment status"
        aria-describedby={isPending ? `${id}-pending` : undefined}
      >
        {MODES.map((mode) => (
          <option
            key={mode}
            value={mode}
            disabled={!availableModes.includes(mode)}
          >
            {formatOptionLabel(mode)}
          </option>
        ))}
      </select>
      {isPending && (
        <span className="pending-label" id={`${id}-pending`}>
          Unsaved change
        </span>
      )}
    </Field>
  );
};

export default EnrollmentStatusSelect;
